import React from 'react';
import ReactDOM from 'react-dom/client';
import { initTheme } from './theme';
import './index.css';
import App from './App';

initTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
